interface LoadingSpinnerProps {
  label?: string;
  size?: number;
  inline?: boolean;
}

/**
 * Branded loading indicator. Spinning favicon. `inline=true` renders a horizontal
 * "[icon] label" suitable for table cells / modal hints; default centers on the page.
 */
export default function LoadingSpinner({ label = 'Loading...', size = 40, inline = false }: LoadingSpinnerProps) {
  const img = (
    <img
      src="/favicon.png"
      alt=""
      aria-hidden="true"
      className="animate-spin"
      style={{ width: size, height: size, willChange: 'transform' }}
    />
  );

  if (inline) {
    return (
      <span className="inline-flex items-center gap-2" role="status" aria-live="polite">
        {img}
        <span className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          {label}
        </span>
      </span>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12" role="status" aria-live="polite">
      {img}
      <span className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
        {label}
      </span>
    </div>
  );
}
